exports.default = {
  'copy_success': '複製{text}成功',
  'copy_failed': '複製{text}失敗',
  'just_now': '剛剛',
  'minutes_ago': '{diff}分鐘前',
  'hours_ago': '{diff}小時前',
  'yesterday': '昨天',
  'month_day': '{month}月{date}日',
  'sun': '日',
  'mon': '一',
  'tue': '二',
  'wed': '三',
  'thu': '四',
  'fri': '五',
  'sat': '六',
  'year': '年',
  'month': '月',
  'day': '日',
  'login_invalid': '登錄失效',
  'account_logged_elsewhere': '賬號已在其他地方登錄！',
  'backend_exception': '後端接口{code}異常',
  'network_connection_failed': '網絡連接失敗，請檢查您的網絡',
  'backend_request_timeout': '後端接口請求超時',
  'backend_exception_code': '後端接口{code}異常',
  'backend_unknown_exception': '後端接口未知異常'
}
